// Google Identity Services Configuration
// This replaces the legacy Google Sign-In and eliminates third-party cookie requirements

export const GOOGLE_CONFIG = {
  // Replace with your actual Google Cloud Console client ID
  // Get this from: https://console.cloud.google.com/apis/credentials
  CLIENT_ID: "695621219400-dirtrog53nft657phikbobnuddgkclfk.apps.googleusercontent.com",

  // Scopes required for authentication
  SCOPES: ["email", "profile"],

  // Modern Google Identity Services settings
  IDENTITY_SERVICES: {
    // Use automatic account selection when possible
    auto_select: false,

    // Cancel authentication when user taps outside
    cancel_on_tap_outside: true,

    // Use FedCM (Federated Credential Management) when available
    // This is the newest, most privacy-friendly method
    use_fedcm_for_prompt: true,

    // One Tap configuration
    one_tap: {
      // Show One Tap on page load
      auto_prompt: true,

      // Delay before showing One Tap (in milliseconds)
      prompt_delay: 1000,

      // Don't show One Tap if user dismissed it recently
      suppress_on_dismissal: true,
    },

    // Button configuration
    button: {
      theme: "outline",
      size: "large",
      text: "continue_with",
      shape: "rectangular",
      logo_alignment: "left",
    },
  },

  // OAuth 2.0 configuration (fallback)
  OAUTH2: {
    // Additional scopes for OAuth flow
    scope: "email profile",

    // Include granted scopes
    include_granted_scopes: true,

    // Response type
    response_type: "token",
  },
};

// Helper function to get the client ID from environment or config
export const getGoogleClientId = () => {
  // Check environment variables first
  if (process.env.REACT_APP_GOOGLE_CLIENT_ID) {
    return process.env.REACT_APP_GOOGLE_CLIENT_ID;
  }

  // Fallback to config
  return GOOGLE_CONFIG.CLIENT_ID;
};

// Helper function to check if Google Identity Services is available
export const isGoogleIdentityServicesAvailable = () => {
  return (
    typeof window !== "undefined" &&
    window.google &&
    window.google.accounts &&
    window.google.accounts.id
  );
};

// Helper function to load Google Identity Services script
export const loadGoogleIdentityServices = () => {
  return new Promise((resolve, reject) => {
    // Check if already loaded
    if (isGoogleIdentityServicesAvailable()) {
      resolve();
      return;
    }

    // Create script element
    const script = document.createElement("script");
    script.src = "https://accounts.google.com/gsi/client";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      console.log("Google Identity Services loaded successfully");
      resolve();
    };

    script.onerror = () => {
      console.error("Failed to load Google Identity Services");
      reject(new Error("Failed to load Google Identity Services"));
    };

    document.head.appendChild(script);
  });
};

// Initialize Google Identity Services with default configuration
export const initializeGoogleIdentityServices = (callback, options = {}) => {
  if (!isGoogleIdentityServicesAvailable()) {
    console.error("Google Identity Services not available");
    return false;
  }

  const config = {
    client_id: getGoogleClientId(),
    callback: callback,
    ...GOOGLE_CONFIG.IDENTITY_SERVICES,
    ...options,
  };

  try {
    window.google.accounts.id.initialize(config);
    console.log("Google Identity Services initialized successfully");
    return true;
  } catch (error) {
    console.error("Error initializing Google Identity Services:", error);
    return false;
  }
};

// Modern Google Sign-In with better UX
export const modernGoogleSignIn = (callback) => {
  if (!isGoogleIdentityServicesAvailable()) {
    console.error("Google Identity Services not available");
    return false;
  }

  try {
    // Show One Tap prompt
    window.google.accounts.id.prompt((notification) => {
      console.log("Google prompt notification:", notification);

      if (notification.isNotDisplayed()) {
        console.log("One Tap not displayed, user may have dismissed it before");
        // Could show a regular sign-in button here
      } else if (notification.isSkippedMoment()) {
        console.log("One Tap skipped by user");
      } else if (notification.isDismissedMoment()) {
        console.log("One Tap dismissed by user");
      }
    });

    return true;
  } catch (error) {
    console.error("Error showing Google prompt:", error);
    return false;
  }
};

export default GOOGLE_CONFIG;
